"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.domainToChainId = exports.chainIdToDomain = exports.chainIdToDomainMapping = void 0;
// Hex domains calculated using `getHexDomainFromString`
// alternative: ethers.BigNumber.from(ethers.utils.toUtf8Bytes("some string")).toNumber()
exports.chainIdToDomainMapping = new Map([
    // mainnets
    [1, 0x657468],
    [10, 0x6f707469],
    [56, 0x626e62],
    [100, 0x676e6f],
    [137, 0x706f6c79],
    [1284, 0x6265616d],
    [42161, 0x6172626f],
    [324, 0x7a6b7363],
    [1101, 0x707a6b6d],
    // testnets
    [42, 0x6b6f7661],
    [5, 0x676f6572],
    [420, 0x676f7074],
    [69, 0x6b6f7074],
    [80001, 0x2707],
    [421613, 0x67617262],
    [10200, 0x63686961],
    [97, 0x63686170],
    [280, 0x7a6b7374],
    [59140, 0x636f6e74],
    [1442, 0x707a6b74],
    // local
    [1337, 133712],
    [1338, 133812],
    [13337, 13337],
    [13338, 13338],
]);
/**
 * Converts a chain id (listed at at chainlist.org) to a domain.
 *
 * @param chainId A chain id number
 * @returns A domain number in decimal
 */
function chainIdToDomain(chainId) {
    const domain = exports.chainIdToDomainMapping.get(chainId);
    if (!domain)
        throw new Error(`Cannot find corresponding domain for chainId ${chainId}`);
    return domain;
}
exports.chainIdToDomain = chainIdToDomain;
/**
 * Converts a domain id  to a chain id. (listed at at chainlist.org)
 *
 * @param domainId A domain id number
 * @returns A chain id
 */
function domainToChainId(domainId) {
    const keys = exports.chainIdToDomainMapping.keys();
    let chainId;
    for (const key of keys) {
        if (exports.chainIdToDomainMapping.get(key) == domainId)
            chainId = key;
    }
    if (!chainId) {
        throw new Error(`Cannot find corresponding chainId for domain ${domainId}`);
    }
    return chainId;
}
exports.domainToChainId = domainToChainId;
//# sourceMappingURL=domain.js.map